import { DEFAULT_GRID_CELL_WIDTH } from '../constants'

import { diffInHours } from './diffInHours'

export const computeDiffGridPositioning = (date: string, start: string) =>
  diffInHours(date, start) * DEFAULT_GRID_CELL_WIDTH
